var map = {
	"./Team=Add selection.png": 5907,
	"./Team=Arsenal.png": 2018,
	"./Team=Aston Villa.png": 2259,
	"./Team=Bournemouth.png": 3172,
	"./Team=Brentford.png": 6620,
	"./Team=Brighton.png": 8233,
	"./Team=Burnley.png": 7923,
	"./Team=Chelsea.png": 6535,
	"./Team=Coventry City.png": 1233,
	"./Team=Coventry.png": 482,
	"./Team=Crystal Palace.png": 4892,
	"./Team=Draft FC GK.png": 6564,
	"./Team=Draft FC.png": 2608,
	"./Team=Everton.png": 455,
	"./Team=Fulham.png": 3059,
	"./Team=Hull City.png": 8774,
	"./Team=Hull.png": 6611,
	"./Team=Ipswich Town.png": 6479,
	"./Team=Ipswich.png": 427,
	"./Team=Leeds.png": 1493,
	"./Team=Leicester.png": 5066,
	"./Team=Liverpool.png": 306,
	"./Team=Luton.png": 8088,
	"./Team=Man City.png": 7,
	"./Team=Man Utd.png": 3389,
	"./Team=Newcastle.png": 1138,
	"./Team=Nott'm Forest.png": 780,
	"./Team=Sheffield Utd.png": 509,
	"./Team=Southampton.png": 6062,
	"./Team=Spurs.png": 9035,
	"./Team=Sunderland.png": 6474,
	"./Team=Unselected.png": 6792,
	"./Team=West Ham.png": 1717,
	"./Team=Wolves.png": 670,
	"./discord.png": 4754,
	"./fpl_draft_enterteam.png": 6964,
	"./fpldraft_enterteam_preseason.png": 3846,
	"./logo_long.png": 5508,
	"./logo_shield.png": 149,
	"./pitch.png": 620,
	"assets/Team=Add selection.png": 5907,
	"assets/Team=Arsenal.png": 2018,
	"assets/Team=Aston Villa.png": 2259,
	"assets/Team=Bournemouth.png": 3172,
	"assets/Team=Brentford.png": 6620,
	"assets/Team=Brighton.png": 8233,
	"assets/Team=Burnley.png": 7923,
	"assets/Team=Chelsea.png": 6535,
	"assets/Team=Coventry City.png": 1233,
	"assets/Team=Coventry.png": 482,
	"assets/Team=Crystal Palace.png": 4892,
	"assets/Team=Draft FC GK.png": 6564,
	"assets/Team=Draft FC.png": 2608,
	"assets/Team=Everton.png": 455,
	"assets/Team=Fulham.png": 3059,
	"assets/Team=Hull City.png": 8774,
	"assets/Team=Hull.png": 6611,
	"assets/Team=Ipswich Town.png": 6479,
	"assets/Team=Ipswich.png": 427,
	"assets/Team=Leeds.png": 1493,
	"assets/Team=Leicester.png": 5066,
	"assets/Team=Liverpool.png": 306,
	"assets/Team=Luton.png": 8088,
	"assets/Team=Man City.png": 7,
	"assets/Team=Man Utd.png": 3389,
	"assets/Team=Newcastle.png": 1138,
	"assets/Team=Nott'm Forest.png": 780,
	"assets/Team=Sheffield Utd.png": 509,
	"assets/Team=Southampton.png": 6062,
	"assets/Team=Spurs.png": 9035,
	"assets/Team=Sunderland.png": 6474,
	"assets/Team=Unselected.png": 6792,
	"assets/Team=West Ham.png": 1717,
	"assets/Team=Wolves.png": 670,
	"assets/discord.png": 4754,
	"assets/fpl_draft_enterteam.png": 6964,
	"assets/fpldraft_enterteam_preseason.png": 3846,
	"assets/logo_long.png": 5508,
	"assets/logo_shield.png": 149,
	"assets/pitch.png": 620
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8141;